/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author ILya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { ELocaleKeys } from '@modules/internationalization/intConstants';
import type IPageSubscriberMobileTranslation from '@modules/internationalization/types/pages/subscriberMobile';
import type { ITableFilterMultiSelect } from '@modules/table';
import declination from '@utils/declination';
import { stringFormatParams } from '@utils/stringFormat';

export const filterMsisdnSearchInputTooltipMsg = (
    maxLength?: number,
    tableFilter?: IPageSubscriberMobileTranslation['tableFilter'],
): ITableFilterMultiSelect['searchInputTooltipMsgCallback'] => {

    if (!maxLength || !tableFilter) return undefined;

    return searchValue => searchValue.length > maxLength
        ? stringFormatParams(tableFilter.msisdn.filtersMaxSize, {
            [ELocaleKeys.number]: maxLength,
            symbol: declination(maxLength, tableFilter.msisdn.filtersMaxSizeSymbol),
        })
        : '';
};
